import EditPagePanel from "./editPagePanel.container";

export default EditPagePanel;
